// Import Tailwind styles from UI package
import "../../ui/src/styles.css";

// Export React components (containers only)
export { SearchBarContainer } from "./components/SearchBarContainer";
export { ResultsContainer } from "./components/ResultsContainer";
export { CheckoutContainer } from "./components/CheckoutContainer";
export {
  RenterDriverCards,
  QuoteRenterDriverCards,
  useRenterDriverCards,
  useRenterDriversConfig,
  type RenterDriverCardsProps,
  type QuoteDriverServerErrors,
  type QuoteRenterDriverCardsProps,
  type RenterDriverCardsState,
} from "./components/renter-drivers";
export {
  ScreeningQuestionsSection,
  type ScreeningQuestionsSectionProps,
} from "./components/ScreeningQuestionsSection";
export {
  buildScreeningPayload,
  validateScreeningAnswers,
  type ScreeningErrors,
  type ScreeningPayload,
  type ScreeningValues,
} from "./lib/screening";
export {
  parseSoftHoldError,
  type ParsedSoftHoldError,
} from "./lib/softHoldErrors";
export {
  getQuoteDeliveryErrorMessage,
  extractErrorCode,
  extractErrorMessage,
} from "./lib/deliveryErrors";
export { PaymentSuccessContainer } from "./components/PaymentSuccessContainer";
export { PaymentErrorContainer } from "./components/PaymentErrorContainer";
export {
  RVDetailContainer,
  type RVDetailContainerProps,
  type CustomerFormData,
} from "./components/RVDetailContainer";
export { EmbedHeaderContainer } from "./components/EmbedHeaderContainer";
export {
  RVSearchContainer,
  type RVSearchContainerProps,
  type RVSearchReservePayload,
  type RVSearchLocation,
} from "./components/RVSearchContainer";
export { FILTER_PARAM_KEYS } from "./components/rv-search-filters/filters";
export { resolveEmbedDate } from "./utils/embedDates";
export {
  getReadableTextColor,
  contrastRatio,
  relativeLuminance,
  parseHexColor,
  withAlpha,
  LIGHT_TEXT_COLOR,
  DARK_TEXT_COLOR,
  type RgbColor,
} from "./utils/readableColor";
export { EmbedSearchBar } from "./components/EmbedSearchBar";
export {
  DepositConsentCheckbox,
  type DepositConsentCheckboxProps,
} from "./components/DepositConsentCheckbox";
export {
  HOLD_RENEWAL_NOTICE,
  holdRenewalNoticeFor,
} from "./components/depositCopy";
export { DepositCardCapture } from "./components/deposit/DepositCardCapture";
export { DepositHoldStatus } from "./components/deposit/DepositHoldStatus";
export {
  useDepositHoldFlow,
  type DepositStage,
} from "./hooks/deposit/useDepositHoldFlow";
export { EmbedProvider, useEmbedContext } from "./contexts/EmbedContext";

// Export hooks
export { useStripeSetup } from "./hooks/useStripeSetup";
export { usePayments } from "./hooks/usePayments";
export { usePaymentMethods } from "./hooks/usePaymentMethods";
export { useQuotes } from "./hooks/useQuotes";
export { useInventory } from "./hooks/useInventory";
export { useRatePlans } from "./hooks/useRatePlans";
export { useCustomers } from "./hooks/useCustomers";
export { useBusinessProfile } from "./hooks/useBusinessProfile";

// Export types
export type {
  UseStripeSetupOptions,
  UseStripeSetupReturn,
} from "./hooks/useStripeSetup";
export type {
  UsePaymentsOptions,
  UsePaymentsReturn,
} from "./hooks/usePayments";
export type {
  UsePaymentMethodsOptions,
  UsePaymentMethodsReturn,
} from "./hooks/usePaymentMethods";
export type {
  UseQuotesOptions,
  UseQuotesReturn,
  CreateQuotePayload,
} from "./hooks/useQuotes";
export type {
  UseInventoryOptions,
  UseInventoryReturn,
} from "./hooks/useInventory";
export type {
  UseRatePlansOptions,
  UseRatePlansReturn,
  RatePlanGridResponse,
  RatePlanFromGrid,
} from "./hooks/useRatePlans";
export type {
  UseCustomersOptions,
  UseCustomersReturn,
} from "./hooks/useCustomers";

// Register Web Components globally (client-side only)
if (typeof window !== "undefined") {
  import("./web-components/CustomButton");
  import("./web-components/GuestsSelector");
  import("./web-components/DateRangeInput");
  import("./web-components/VehicleCategorySelector");
  import("./web-components/SearchBar");
  import("./web-components/Results");
  import("./web-components/Checkout");
  import("./web-components/PaymentSuccess");
  import("./web-components/PaymentError");
  import("./web-components/RVDetail");
  import("./web-components/RVSearch");
}
